import { MNHotInstance } from '../../../../bridge/tableHotInstanceTypes';

export const MANUAL_COLUMN_RESIZER_HANDLE_CLASS_NAME = 'manualColumnResizerHandle';

/**
 * Ensures each rendered column header has Milanote's custom resize handle attached.
 */
export const createManualColumnResizerHandlesInDOM = (
    hotInstance: MNHotInstance,
): { thElement: HTMLTableCellElement; resizeHandleElement: HTMLDivElement }[] => {
    const colRefHeaderElement = hotInstance.rootElement.querySelector('.ht_clone_top');
    const thElements = Array.from(colRefHeaderElement?.querySelectorAll('th') || []);
    const rootDocument = hotInstance.rootDocument || document;

    thElements.shift();

    return thElements.reduce<{ thElement: HTMLTableCellElement; resizeHandleElement: HTMLDivElement }[]>(
        (acc, thElement) => {
            if (thElement.querySelector(`.${MANUAL_COLUMN_RESIZER_HANDLE_CLASS_NAME}`)) return acc;

            // We own the resize hit area so touch devices can opt out of canvas scrolling during resize.
            const resizeHandleElement = rootDocument.createElement('div');
            resizeHandleElement.className = MANUAL_COLUMN_RESIZER_HANDLE_CLASS_NAME;
            resizeHandleElement.dataset.ignoreTouchMove = 'true';
            resizeHandleElement.style.touchAction = 'none';

            thElement.appendChild(resizeHandleElement);

            acc.push({ thElement, resizeHandleElement });
            return acc;
        },
        [],
    );
};
